import path from "./pathSettings";

export const pagesWithoutNav = [path('login'), path('siteSelection')]